import { apiGet, apiPost, apiPatch, apiPut } from "./client";
export const SEASON_STATUS = {
  draft: "Подготовка",
  recruiting: "Идёт набор",
  active: "Идёт интенсив",
  completed: "Завершён",
};
export const PARTICIPATION_STATUS = {
  applied: "Заявка на рассмотрении",
  accepted: "Участник сезона",
  rejected: "Отбор не пройден",
  withdrawn: "Участие отменено",
};
export const getSeasons = () => apiGet("/seasons", { season: false });
export const getMySeasons = () => apiGet("/me/seasons", { season: false });
export const applyToSeason = (id) =>
  apiPost(`/seasons/${id}/apply`, {}, { season: false });
export const saveSeason = (id, data) =>
  id
    ? apiPatch(`/admin/seasons/${id}`, data, { season: false })
    : apiPost("/admin/seasons", data, { season: false });
export const copySeasonContent = (id, data) =>
  apiPost(`/admin/seasons/${id}/copy-content`, data, { season: false });
export const getSeasonParticipants = ({ seasonId, ...params }) =>
  apiGet(
    `/admin/seasons/${seasonId}/participants?${new URLSearchParams(params)}`,
    { season: false },
  );
export const saveSeasonParticipant = (id, userId, data) =>
  apiPut(`/admin/seasons/${id}/participants/${userId}`, data);
export const getContentSeason = (kind, id) =>
  apiGet(`/seasons/resolve/${kind}/${id}`, { season: false });
export const getSeasonSummary = (seasonId) =>
  apiGet(`/admin/seasons/${seasonId}/summary`, { season: false });
